import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ClaimDirective } from 'src/app/directive/claim.directive';
import { RoleListItem } from 'types/role.interface';
import { CLAIM_SCOPES, CLAIM_TYPES } from 'types/user.interface';

@Component({
  selector: 'app-role',
  standalone: true,
  imports: [NgbCollapse, TranslateModule, NgClass, ClaimDirective],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss'
})
export class RoleComponent {
  public readonly CLAIM_SCOPE = CLAIM_SCOPES['role'];
  public readonly CLAIM_TYPES = CLAIM_TYPES;
  @Input() roles!: RoleListItem[] | any[];
  @Input() isSystemRoles: boolean = true;
  isCollapsed: boolean = false;

  constructor(private router: Router) {}

  onCopy(): void {
    return;
  }

  onEdit(id: number): void {
    this.router.navigate([`/lomas/${id}/rediget`]);
  }

  onView(id: number): void {
    this.router.navigate([`/lomas/${id}`]);
  }
}
